import coursesApi from "../../api/courses";

const state = {
  courseSuggestions: []
};

const getters = {};

const actions = {
  populateCourseSuggestions(context, course) {
    return new Promise((resolve, reject) => {
      if (course.subjectCode || course.catalogNumber || course.courseTitle) {
        coursesApi
          .getCourseSuggestions(
            course.subjectCode,
            course.catalogNumber,
            course.courseTitle
          )
          .then(function(response) {
            context.commit("updateCourseSuggestions", response.data);
            resolve(response);
          })
          .catch(function(error) {
            console.log(error);
            reject(error);
          });
      } else {
        context.commit("updateCourseSuggestions", []);
      }
    });
  }
};

const mutations = {
  updateCourseSuggestions(state, value) {
    state.courseSuggestions = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
